export const RESET_PASSWORD_REQUESTING =
  'resetPassword/RESETPASSWORDREQUESTING';
export const RESET_PASSWORD_ENDED = 'resetPassword/RESETPASSWORDENDED';
export const RESET_PASSWORD_ERROR = 'resetPassword/RESETPASSWORDERROR';
export const RESET_PASSWORD_ERROR_USER = 'resetPassword/RESETPASSWORDERRORUSER';
export const RESET_ERRORS = 'resetPassword/RESETERRORS';
export const REQUEST_RESPONSE = 'resetPassword/REQUESTRESPONSE';
